import { createI18n } from 'vue-i18n';
import { messages } from './locales';

const stored = (typeof window !== 'undefined' && localStorage.getItem('locale')) || 'da'

const i18n = createI18n({
  legacy: false,
  locale: stored,
  fallbackLocale: 'en',
  messages,
});

export default i18n;
export const initialLocale = stored